export const deepTrim = (data: unknown): unknown => {
  switch (typeof data) {
    case 'string':
      return data.trim();
    case 'object':
      return trimObject(data);
    default:
      return data;
  }
};

const trimObject = (data: object | null): unknown => {
  if (!data) return null;

  if (data instanceof FormData) {
    const result = new FormData();
    data.forEach((value, key) => {
      result.set(key, typeof value === 'string' ? value.trim() : value);
    });
    return result;
  }

  if (Array.isArray(data)) {
    return data.map(value => deepTrim(value));
  }

  const result: Record<string, unknown> = { ...data };
  Object.entries(data).forEach(([key, value]) => {
    result[key] = deepTrim(value);
  });
  return result;
};
